<template>
  <b-col lg="12">
    <b-col>
      <div class="demo-inline-spacing">
        <b-button
            class="mr-2 bg-secondary bg-darken-2 border-0"
            :to="{ name: 'pedidos-vendas' }"
            v-if="botoesExibir.includes('Voltar')"
            @click="voltar"
        >
          <feather-icon icon="ArrowLeftCircleIcon" size="18"/>
          Voltar
        </b-button>
        <b-button
            class="mr-2 bg-warning bg-darken-2 border-0"
            v-if="botoesExibir.includes('Alterar')"
        >
          <feather-icon icon="Edit2Icon" size="18"/>
          Alterar
        </b-button>
        <b-button
            class="mr-2 bg-dark bg-darken-2 border-0"
            v-if="botoesExibir.includes('Finalizar')"
        >
          <feather-icon icon="CheckCircleIcon" size="18"/>
          Finalizar
        </b-button>
        <b-button
            class="mr-2 bg-danger bg-darken-2 border-0"
            v-if="botoesExibir.includes('Cancelar')"
        >
          <feather-icon icon="XCircleIcon" size="18"/>
          Cancelar
        </b-button>
        <b-button
            class="mr-2 bg-success bg-darken-2 border-0"
            v-if="botoesExibir.includes('Copiar')"
        >
          <feather-icon icon="CopyIcon" size="18"/>
          Copiar
        </b-button>
<!--        <b-button-->
<!--            class="mr-2 bg-warning bg-darken-2 border-0"-->
<!--        >-->
<!--          <feather-icon icon="AlignJustifyIcon" class="rotate-icon" size="18"/>-->
<!--          Boleto-->
<!--        </b-button>-->
      </div>
    </b-col>
    <b-col md="12" class="mt-2">
      <b-card no-body>
        <b-card-header :header-bg-variant="`secondary bg-lighten-5`" class="w-100">
                    <b-card-title>Pedidos</b-card-title>
          <div class="demo-inline-spacing">
             <h3>
               <b-badge size="xl" variant="success">
                 NR Pré-Pedido : {{getCapaPedido.pedidoid}}
               </b-badge>
             </h3>
            <h3>
              <b-badge variant="success" >
              Pedido ERP : {{getCapaPedido.pedidonumerointegracao}}
              </b-badge>
            </h3>
          </div>
        </b-card-header>
        <b-tabs card pills nav-class="nav-pill-primary">
          <b-tab>
            <template #title>
              <feather-icon icon="PocketIcon"/>
              <span>Condições</span>
            </template>
            <b-row>
              <b-col class="mt-2 mb-2">
                <b-row class="mb-12">
                  <b-col md="3">
                    <b-form-group label="NR Pré-Pedido">
                      <b-form-input type="number" placeholder="" v-model="getCapaPedido.pedidoid" disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Pedido ERP">
                      <b-form-input type="number" placeholder="" v-model="getCapaPedido.pedidonumerointegracao" disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="Status">
                      <b-form-input type="text" placeholder="" v-model="getCapaPedido.pedidositsales" disabled/>
                    </b-form-group>
                  </b-col>

                  <b-col v-if="!ocultarInfoComercial" md="2">
                    <b-form-group label="Representante">
                      <b-form-input type="number" placeholder="" v-model="getCapaPedido.representanteid" disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col v-if="!ocultarInfoComercial" md="4">
                    <b-form-group label="Nome representante">
                      <b-form-input type="text" placeholder="" v-model="getCapaPedido.representantenome" disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group label="Estabelecimento">
                      <b-form-input type="number" placeholder="" v-model="getCapaPedido.estabelecimentoid"
                                    disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Estabelecimento Razãosocial">
                      <b-form-input type="text" placeholder="" v-model="getCapaPedido.estabelecimentorazaosocial"
                                    disabled/>
                    </b-form-group>
                  </b-col>

                  <b-col md="2">
                    <b-form-group label="Cliente">
                      <b-form-input type="number" placeholder="" v-model="getCapaPedido.clienteiderp" disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Cliente Razãosocial">
                      <b-form-input type="text" placeholder="" v-model="getCapaPedido.clienterazaosocial"
                                    disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col v-if="!ocultarTabelaCondicao" md="2">
                    <b-form-group v-if="$store.getters['preferencias/condicaoPagamentoAtiva']" label="Condição de Pagamento">
                      <b-form-input type="number" placeholder="" v-model="getCapaPedido.condicaopagamentoid"
                                    disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col v-if="!ocultarTabelaCondicao" md="4">
                    <b-form-group v-if="$store.getters['preferencias/condicaoPagamentoAtiva']" label="Condição de Pagamento Descrição">
                      <b-form-input type="text" placeholder="" v-model="getCapaPedido.condicaoPagamentoDescricao"
                                    disabled/>
                    </b-form-group>
                  </b-col>

                  <b-col v-if="!ocultarTabelaCondicao" md="2">
                    <b-form-group label="Tabela de preço">
                      <b-form-input type="number" placeholder="" v-model="getCapaPedido.clienteiderp" disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Cliente Razãosocial">
                      <b-form-input type="text" placeholder="" v-model="getCapaPedido.clienterazaosocial"
                                    disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Usuário">
                      <b-form-input type="text" placeholder="" v-model="getCapaPedido.usuario_nome" disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group label="Data Emissão">
                      <b-form-input type="date" placeholder="" v-model="getCapaPedido.pedidositcreditodata" disabled/>
                    </b-form-group>
                  </b-col>

                  <b-col md="2">
                    <b-form-group label="Nr. OC">
                      <b-form-input type="number" placeholder="" disabled/>
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group label="Observações">
                      <b-form-textarea
                          id="textarea-rows"
                          placeholder="Observações...."
                          v-model="getCapaPedido.pedidoobservacoes"
                          rows="8"
                          disabled
                      />
                    </b-form-group>
                  </b-col>
<!--                  <b-col md="12">-->
<!--                    <b-form-group label="Observações">-->
<!--                      <b-form-textarea-->
<!--                          id="textarea-rows"-->
<!--                          placeholder="Tall textarea"-->
<!--                          rows="8"-->
<!--                      />-->
<!--                    </b-form-group>-->
<!--                  </b-col>-->
                </b-row>
              </b-col>
              <b-col cols="12">
                <hr>
              </b-col>
              <b-col class="mt-2 mb-2">
                <b-card no-body>
                  <b-card-header :header-bg-variant="`secondary bg-lighten-5`" class="w-100">
                    <b-card-title>Total de Pedido</b-card-title>
                  </b-card-header>
                  <b-row class="mb-12 mt-2">
                    <b-col md="6">
                      <b-form-group label="Valor Total Produtos">
                        <b-form-input type="text" placeholder="" :value="dinheiroVisual(somaVisual(getItensPedido))" disabled/>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group label="Quantidade total">
                        <b-form-input type="number" placeholder="" disabled/>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab>
            <template #title>
              <feather-icon icon="ListIcon"/>
              <span>Itens</span>
            </template>
            <b-table
                :per-page="getMeta.pageSize"
                :items="getItensPedido"
                :fields="fieldsVisuais"
                striped
                responsive
                :striped="true"
                :bordered="true"
                :hover="true"
            >
              <template #cell(PrecoUnitario)="row">
                {{ dinheiroVisual(precoUnitarioVisual(row.item)) }}
              </template>
              <template #cell(ValorTotal)="row">
                {{ dinheiroVisual(subtotalVisual(row.item)) }}
              </template>
              <template #cell(mostrar_detalhes)="row">
                <b-form-checkbox
                    v-model="row.detailsShowing"
                    plain
                    class="vs-checkbox-con"
                    @change="row.toggleDetails"
                >
          <span class="vs-checkbox">
            <span class="vs-checkbox--check">
              <i class="vs-icon feather icon-check"/>
            </span>
          </span>
                  <span class="vs-label">{{ row.detailsShowing ? 'Ocultar' : 'Mostrar' }}</span>
                </b-form-checkbox>
              </template>

              <template #row-details="row">
                <b-card>
                  <b-table
                      responsive="sm"
                      :fields="fieldsSubVisuais"
                      :items="row.item.itens"
                      :striped="true"
                      :bordered="true"
                      :hover="true"
                      table-variant="outline-secondary"
                  >
                    <template #cell(precoUnitario)="subRow">
                      {{ dinheiroVisual(precoUnitarioVisual(subRow.item)) }}
                    </template>
                    <template #cell(valorTotal)="subRow">
                      {{ dinheiroVisual(subtotalVisual(subRow.item)) }}
                    </template>
                  </b-table>

                  <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="row.toggleDetails"
                  >
                    Ocultar Detalhes
                  </b-button>
                </b-card>
              </template>

              <template #cell(editar)="data">
                <b-button
                    size="sm"
                    class="mr-2 bg-primary bg-darken-2 border-0"
                >
                  <feather-icon icon="EditIcon" class="rotate-icon"/>
                </b-button>
              </template>

              <template #cell(excluir)="data">
                <b-button
                    size="sm"
                    class="mr-2 bg-danger bg-darken-5 border-0"
                >
                  <feather-icon icon="TrashIcon"/>
                </b-button>
              </template>
            </b-table>
            <b-col  class="w-100">
              <b-row >
                <b-col sm="5" md="4" class="my-1">
                  <b-form-group
                      label="paginação"
                      label-for="per-page-select"
                      label-cols-sm="6"
                      label-cols-md="4"
                      label-cols-lg="3"
                      label-align-sm="right"
                      label-size="sm"
                      class="mb-0"
                  >
                    <b-form-select
                        id="per-page-select"
                        v-model="getMetaItens.pageSize"
                        :options="pageOptions"
                        @change="pageSelect"
                        size="lg"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col sm="7" md="6" class="my-1">
                  <b-pagination
                      v-model="getMetaItens.page"
                      :total-rows="getMetaItens.total"
                      :per-page="getMetaItens.pageSize"
                      @input="linkGen"
                      align="Right"
                      size="lg"
                      class="my-0"
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-col>
          </b-tab>
          <b-tab>
            <template #title>
              <feather-icon icon="TruckIcon"/>
              <span>Entrega</span>
            </template>
            <b-row>
              <b-col md="2">
                <b-form-group v-if="$store.getters['preferencias/exibirDataPrevistaEntrega'] !== false" label="Data Estimada Entrega">
                  <b-form-input type="date" placeholder="" v-model="getCapaPedido.pedidodataentrega" disabled/>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Endereço">
                  <b-form-input type="text" placeholder="" v-model="getEnderecoEntrega.clienteendereco" disabled/>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="CEP">
                  <b-form-input type="number" placeholder="" v-model="getEnderecoEntrega.clienteenderecocep" disabled/>
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group label="Bairro">
                  <b-form-input type="text" placeholder="" v-model="getEnderecoEntrega.clienteenderecobairro" disabled/>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Cidade">
                  <b-form-input type="text" placeholder="" v-model="getEnderecoEntrega.clienteenderecocidade" disabled/>
                </b-form-group>
              </b-col>
              <b-col md="1">
                <b-form-group label="Estado">
                  <b-form-input type="text" placeholder="" v-model="getEnderecoEntrega.ufid" disabled/>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-col>
  </b-col>
</template>

<script>
import precoVisualizacaoMixin from '../pedidosVendas/modal/precoVisualizacao.mixin';
import {
  BTabs,
  BTab,
  BCardText,
  BCard,
  BCol,
  BCardHeader,
  BFormSelect,
  BFormInput,
  BRow,
  BFormGroup, BButton, BTable, BFormCheckbox, BCardFooter,
} from 'bootstrap-vue';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import { mapActions, mapGetters } from 'vuex';
import Store from '@/store';
import { ocultarInfoComercialCliente, ocultarTabelaCondicaoRepresentante, ocultarTabelaCondicaoSupervisor } from '@/libs/perfilCliente';

export default {
  mixins: [precoVisualizacaoMixin],
  components: {
    BCardFooter,
    BButton,
    BFormGroup,
    BRow,
    BFormInput,
    BFormSelect,
    BCardHeader,
    BCol,
    BCard,
    BCardText,
    BTabs,
    BTab,
    BTable,
    BFormCheckbox,
    AppCollapse,
    AppCollapseItem,
  },
  data: () => ({
    pageOptions: [5, 10, 15, 20],
    page: 1,
    pageZise: 5,
    collapseType: 'border',
    fields: ['mostrar_detalhes', { key: 'DescricaoMarca', label: 'Marca', sortable: true }, {
      key: 'referencia',
      label: 'Referência',
      sortable: true,
    }, { key: 'DescricaoEmbalagem', label: 'Embalagem', sortable: true }, {
      key: 'sequencia',
      label: 'Sequência',
      sortable: true,
    }, { key: 'PrecoUnitario', label: 'Valor Unitario', sortable: true }, {
      key: 'Qtde',
      label: 'Quantidade',
      sortable: true,
    }, { key: 'ValorTotal', label: 'Valor Total', sortable: true }, {
      key: 'editar',
      label: 'Editar',
      sortable: true,
    }, { key: 'excluir', label: 'Excluir', sortable: true }],
    fieldsSub: [
      { key: 'itemId', label: 'Código', sortable: true },
      { key: 'item_descricao', label: 'Descrição', sortable: true },
      { key: 'marca', label: 'Marca', sortable: true },
      { key: 'des_cor', label: 'Cor', sortable: true },
      { key: 'embalagem', label: 'Embalagem', sortable: true },
      { key: 'pedidoItemQuantidade', label: 'QTD', sortable: true },
      { key: 'precoUnitario', label: 'Valor Unitario', sortable: true },
      { key: 'valorTotal', label: 'Valor Total', sortable: true },
      { key: 'pedidoItemQuantidadeSaldo', label: 'QTD Saldo', sortable: true },
      { key: 'pedidoItemQuantidadeFaturada', label: 'QTD Faturado', sortable: true },
    ],
  }),
  mounted() {
    this.detalhePedido(this.$route.params.pedidoid, this.$route.params.clienteid);
  },
  methods: {
    ...mapActions('SLS_PedidosVendas', ['setFilters', 'retornaPedidoVendas', 'listarCapaPedido', 'enderecoEntregaPedido', 'retornaItensPedido', 'setFiltersItens', 'clearFilters']),
    async detalhePedido(pedidoid, clienteid) {
      await this.listarCapaPedido(pedidoid);
      await this.enderecoEntregaPedido(clienteid);
      await this.retornaItensPedido(pedidoid);
    },
    async pageSelect(event) {
      const pageSize = parseInt(event);
      await this.setFiltersItens({ pageSize });
      await this.detalhePedido(this.$route.params.pedidoid, this.$route.params.clienteid);
    },
    async linkGen(pageNum) {
      const page = parseInt(pageNum);
      await this.setFiltersItens({ page });
      await this.detalhePedido(this.$route.params.pedidoid, this.$route.params.clienteid);
    },
    async voltar() {
      await this.clearFilters();
    },
  },
  computed: {
    fieldsVisuais() {
      return this.fields.map(field => field.key === 'PrecoUnitario'
        ? { ...field, label: this.rotuloUnitarioVisual(field.label) } : field);
    },
    fieldsSubVisuais() {
      return this.fieldsSub.map(field => field.key === 'precoUnitario'
        ? { ...field, label: this.rotuloUnitarioVisual(field.label) } : field);
    },
    ...mapGetters({
      getPedidoVendas: 'SLS_PedidosVendas/getPedidoVendas',
      getMeta: 'SLS_PedidosVendas/getMeta',
      getCapaPedido: 'SLS_PedidosVendas/getCapaPedido',
      getEnderecoEntrega: 'SLS_PedidosVendas/getEnderecoEntrega',
      getItensPedido: 'SLS_PedidosVendas/getItensPedido',
      getMetaItens: 'SLS_PedidosVendas/getMetaItens',
    }),
    // Preferência CLIENTE_OCULTAR_INFO_COMERCIAL: esconde (só visualmente)
    // representante, condição de pagamento e tabela de preço p/ perfil Cliente.
    ocultarInfoComercial() {
      return ocultarInfoComercialCliente(this.$store);
    },
    // Preferência REPRESENTANTE_OCULTAR_INFO_COMERCIAL: esconde (só visualmente)
    // APENAS tabela de preço e condição de pagamento p/ perfil Representante.
    ocultarTabelaCondicao() {
      return this.ocultarInfoComercial || ocultarTabelaCondicaoRepresentante(this.$store) || ocultarTabelaCondicaoSupervisor(this.$store);
    },
    botoesExibir() {
      const statusPedido = this.getCapaPedido?.pedidositsales;
      const botoesPorStatus = {
        CANCELADO: ['Voltar'],
        DIGITADO: ['Voltar', 'Alterar', 'Finalizar', 'Cancelar', 'Copiar'],
        EXCLUIDO: ['Voltar'],
        INTEGRADO: ['Voltar', 'Copiar'],
        RECALCULAR: ['Voltar', 'Cancelar', 'Copiar', 'Recalcular'],
        REJEITADO: ['Voltar', 'Alterar', 'Finalizar', 'Cancelar', 'Copiar'],
        SUBMETIDOS: ['Voltar', 'Copiar'],
      };
      return statusPedido ? botoesPorStatus[statusPedido] : [];
    },
  },
};
</script>
<style scoped>
.rotate-icon {
  transform: rotate(90deg);
}

</style>
